<template>
  <p
    class="description"
    v-text="description"
  />
</template>

<script>
  export default {
    props: {
      description: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .description {
    color: color(bronze);
    line-height: line-height(copy);

    @include breakpoint(phablet) {
      margin-left: 10%;
      width: 80%;
    }

    @include breakpoint(tablet) {
      width: 50%;
    }
  }
</style>
